import * as THREE from "three";
import loadingManager from "./loader.js";

export default function materials(scene){
    const textureLoader = new THREE.TextureLoader(loadingManager)

    const ColorTextureBlack = textureLoader.load('./textures/black/black_painted_planks_diff_1k.webp')
    const ARMTextureBlack = textureLoader.load('./textures/black/black_painted_planks_arm_1k.webp')
    const NormalTextureBlack = textureLoader.load('./textures/black/black_painted_planks_nor_gl_1k.webp')
    const DisplacementTextureBlack = textureLoader.load('./textures/black/black_painted_planks_disp_1k.webp')

    ColorTextureBlack.colorSpace = THREE.SRGBColorSpace


    const materialBlackPainted =     new THREE.MeshStandardMaterial({
        map: ColorTextureBlack,
        aoMap: ARMTextureBlack,
        roughnessMap: ARMTextureBlack,
        metalnessMap: ARMTextureBlack,
        normalMap: NormalTextureBlack,
        displacementMap: DisplacementTextureBlack,
        displacementScale: 0.005,
    })

    materialBlackPainted.normalScale.set(1.5, 1.5)
    materialBlackPainted.aoMapIntensity = 1.0
    materialBlackPainted.roughness = 0.45
    materialBlackPainted.metalness = 0.05



    const ColorTextureWood = textureLoader.load('./textures/wood/wood_table_worn_diff_1k.webp')
    const ARMTextureWood = textureLoader.load('./textures/wood/wood_table_worn_arm_1k.webp')
    const NormalTextureWood = textureLoader.load('./textures/wood/wood_table_worn_nor_gl_1k.webp')
    const DisplacementTextureWood = textureLoader.load('./textures/wood/wood_table_worn_disp_1k.webp')


    ColorTextureWood.colorSpace = THREE.SRGBColorSpace


    const materialWood =     new THREE.MeshStandardMaterial({
        map: ColorTextureWood,
        aoMap: ARMTextureWood,
        roughnessMap: ARMTextureWood,
        metalnessMap: ARMTextureWood,
        normalMap: NormalTextureWood,
        displacementMap: DisplacementTextureWood,
        displacementScale: 0.002,
    })

    materialWood.normalScale.set(1.5, 1.5)
    materialWood.aoMapIntensity = 1.0
    materialWood.roughness = 0.6
    materialWood.metalness = 0

    const materialArray = [materialBlackPainted, materialWood]

    const tempGeo = new THREE.PlaneGeometry(0.001, 0.001, )

    function warmUpMaterials(materialArray){
        materialArray.forEach((item)=>{
            const tempMeshWood = new THREE.Mesh(tempGeo, item)
            tempMeshWood.visible = true
            scene.add(tempMeshWood)
        })
    }

    warmUpMaterials(materialArray)

    return {materialBlackPainted, materialWood}
}